import { withAuth } from 'context/Auth';
import withContainer from 'components/Container/withContainer';
import { SelectField } from 'ui/Select';
import { Form } from 'ui/FormContainer/FormContainer';
import { makeCreateFormFunc } from 'utils/api';
import Button from 'ui/Button/Button';
import ButtonsContainer from 'ui/Button/ButtonContainer';
import { addDocumentTemplate } from './templates';
import { EducationCenterField2 } from 'components/fields/EducationCenterField';
import { AddTemplateData } from './temlatesTypes.types';
import {
    extendedDocumentTypeOptions,
    documentTypeOptions
} from 'messages/options';
import { FileFieldContainer, FormRow } from 'ui/Form/Form.styled';
import FormField from 'ui/FormField/FormField';

type Data = AddTemplateData;

const Select = SelectField<Data>;
const Field = FormField<Data>;

const handleFormSubmit = makeCreateFormFunc(
    addDocumentTemplate,
    'Шаблон документа загружен!'
);

const UploadDocumentsForm = () => {
    return (
        <Form onSubmit={handleFormSubmit}>
            {({ submitting }) => (
                <>
                    <EducationCenterField2 />
                    <Select
                        name="documentType"
                        label="Тип документа"
                        options={documentTypeOptions}
                        required
                    />
                    <Select
                        name="extendedDocumentType"
                        label="Шаблон документа"
                        options={extendedDocumentTypeOptions}
                        required
                    />
                    <FormRow>
                        <FileFieldContainer>
                            <Field
                                type="file"
                                name="file"
                                label="Файл шаблона"
                                required
                            />
                        </FileFieldContainer>
                    </FormRow>
                    <ButtonsContainer>
                        <Button type="submit" disabled={submitting}>
                            Загрузить
                        </Button>
                    </ButtonsContainer>
                </>
            )}
        </Form>
    );
};

export default withAuth(
    withContainer(UploadDocumentsForm, {
        heading: 'Загрузка шаблонов'
    })
);
